import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { required } from "@/commons/utils/Rules";
import baseform2 from '../baseForm2';
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import PzDirection from "@/commons/forms/Fields/PzDirection";
import { mapGetters } from "vuex";
import { getFormasDeEnterarse } from "@/routes/api/resources";
export default {
  name: 'PzPersonFormExtFucerep',
  components: {
    PzFormFlujo: PzFormFlujo,
    PzDirection: PzDirection
  },
  mixins: [baseform2],
  data: function data() {
    return {
      formas_de_enterarse: [],
      formulario2: {
        comoseentero: '',
        direccion: {}
      },
      rules_formulario2: {
        comoseentero: [required('')]
      }
    };
  },
  created: function created() {
    this.fechtData();
  },
  methods: {
    fechtData: function fechtData() {
      var _this = this;
      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      var form = getFormasDeEnterarse().then(function (res) {
        _this.formas_de_enterarse = res.data;
      }).catch(function () {
        _this.formas_de_enterarse = [];
      });
      return Promise.all([form]).then(function () {}).finally(function () {
        _this.$store.dispatch('loader/down', {
          trigger: _this.$options.name
        });
      });
    }
  }
};